import { render, staticRenderFns } from "./PracticeItem.vue?vue&type=template&id=4cf40adc&scoped=true&"
import script from "./PracticeItem.vue?vue&type=script&lang=js&"
export * from "./PracticeItem.vue?vue&type=script&lang=js&"
import style0 from "./PracticeItem.vue?vue&type=style&index=0&id=4cf40adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf40adc",
  null
  
)

export default component.exports